import React, { Suspense, lazy } from 'react';
import { MemoryRouter as Router, Switch, Route } from 'react-router-dom';
import { Typography, Div } from '@icecreamsocial/components';
import { flags } from '../../../utils/featureFlags';
import { ConditionalRoute } from '../../presentational';
import PopsicleLoader from '../../presentational/PopsicleLoader';

/**
 * Offer pages
 */
const OfferOptIn = flags.isActive(flags.names.ENABLE_EXPERIMENTAL_CONSENT_STEP)
	? lazy(() =>
			import('./views/OfferOptInConsent').then(({ OfferOptInConsent }) => ({
				default: OfferOptInConsent,
			}))
	  )
	: lazy(() =>
			import('./views/OfferOptIn').then(({ OfferOptIn }) => ({
				default: OfferOptIn,
			}))
	  );

/**
 * Share options page
 */
const ShareOptions = lazy(() =>
	import('./views/ShareOptions').then(({ ShareOptions }) => ({
		default: ShareOptions,
	}))
);

/**
 * Offer claim page
 */
const OfferClaim = lazy(() =>
	import('./views/OfferClaim').then(({ OfferClaim }) => ({
		default: OfferClaim,
	}))
);

/**
 * thank you page
 */
const ThankYou = lazy(() =>
	import('./views/ThankYou').then(({ ThankYou }) => ({ default: ThankYou }))
);

export const Main = () => {
	return (
		<Suspense
			fallback={
				<Div
					padding='xlg'
					textAlign='center'
					borderRadius='default'
					marginBottom='xlg'
				>
					<PopsicleLoader />
					<Typography.P marginTop='none'>Just a moment...</Typography.P>
				</Div>
			}
		>
			<Router>
				<Switch>
					<Route path='/' exact>
						<OfferOptIn />
					</Route>
					{/* { only show this if they were invited and there is an offer } */}
					<ConditionalRoute
						path='/offer-code'
						shouldRedirect={false}
						redirectPath={'/'}
					>
						<OfferClaim />
					</ConditionalRoute>
					<Route path='/share'>
						<ShareOptions />
					</Route>
					<Route path='/thank-you'>
						<ThankYou />
					</Route>
				</Switch>
			</Router>
		</Suspense>
	);
};
